<template>
  <div>
    <p class="cm-mg-p-wzd text-center text-muted">
      {{ $t('vie.Pag.Das.Bus.ste.SecondStep.text1') }}
    </p>
    <hr />
    <select-address
      ref="selectAddress"
      :requiredFields="requireAddress"
      :showZipCode="false"
      @showHideLoading="showHideLoading"
      @onChange="handleChangeSelected"
    />
  </div>
</template>
<script>
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';

export default {
  data() {
    return {
      model: {
        address: null,
        country: null,
        city: null,
        state: null,
      },
      requireAddress: true,
    };
  },
  mixins: [MixinPermissions, mixinMasters],
  methods: {
    validate() {
      return this.$validator.validateAll().then((response) => {
        if (!response) return false;

        if (!this.requireAddress) {
          this.$emit('on-validated', response, this.model);
          this.$emit('fillBusinessForm', 'secondStep');

          return true;
        }

        return new Promise((resolve) => {
          this.$refs.selectAddress.$emit('validateAddress', (isValid) => {
            if (isValid) {
              this.$emit('on-validated', response, this.model);
              this.$emit('fillBusinessForm', 'secondStep');
            }

            resolve(isValid);
          });
        });
      });
    },

    handleChangeSelected(data) {
      this.$set(this.model, data.name, data.selects);
    },
  },

  mounted() {
    let editForm = {};
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      editForm = JSON.parse(sessionStorage.getItem('editForm'));
      this.model.address = editForm.address;
      this.model.country = editForm.country;
      this.model.state = editForm.state;
      this.model.city = editForm.city;
    }
  },
};
</script>
<style></style>
